export const approveDocsButton = 'Stay on this page and approve documents now';
